import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=31c570bb"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=31c570bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports